import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { MenuAcceleratorBadge } from 'features/menu/components/menu-accelerator-badge';
import {
  PriceAndCaloriesListWrapper,
  Tile,
  TileDescription,
  TileHeader,
  TileImage,
  TileImageWrapper,
} from 'features/menu/components/menu-tile-grid/styled';
import {
  IMenuTileProps,
  IPriceAndCaloriesProps,
} from 'features/menu/components/menu-tile-grid/types-badges-experiment';

import { Calories } from 'components/price-and-calories';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

const ItemCalories = Text.withConfig({
  numberOfLines: 1,
  color: getDesignToken('color-tertiary'),
  marginTop: '1',
  marginBottom: '0',
  textTransform: 'capitalize',
});

const StyledItemPrice = Text.withConfig({
  fontWeight: 'bold',
  color: getDesignToken('color-pricing'),
  marginTop: '1',
  marginRight: {
    base: '1',
    md: '0',
  },
});

const priceAndCalories = ({
  calories,
  price,
  type,
}: IPriceAndCaloriesProps): JSX.Element | null => {
  const shouldRenderPriceAndCalories = price || calories;
  if (type === 'section' || !shouldRenderPriceAndCalories) {
    return null;
  }

  return (
    <PriceAndCaloriesListWrapper>
      <StyledItemPrice>{price}</StyledItemPrice>
      <Calories>
        <ItemCalories>{calories}</ItemCalories>
      </Calories>
    </PriceAndCaloriesListWrapper>
  );
};

const MenuTile = React.memo(
  ({
    pathname,
    image,
    objectFitContain,
    calories,
    name,
    type,
    price,
    id,
    accessibilityLabel = '',
    accessibilityLevel = 3,
    accessibilityRole = 'header',
    badge,
  }: IMenuTileProps) => {
    const priceAndCaloriesContent = priceAndCalories({ type, price, calories });

    return (
      <Tile
        testID="menu-tile-bk"
        accessibilityRole={accessibilityRole}
        accessibilityLevel={accessibilityLevel}
        accessibilityLabel={accessibilityLabel}
      >
        <TileImageWrapper>
          {!!badge && (
            <MenuAcceleratorBadge
              position="absolute"
              pointsMultiplier={badge.pointsMultiplier}
              bonusPoints={badge.bonusPoints}
            />
          )}
          <TileImage
            image={image}
            alt={''}
            objectFitContain={objectFitContain}
            accessibilityHint={t('select')}
          />
        </TileImageWrapper>
        <TileDescription>
          <TileHeader testID={`tile-header-${name?.toLowerCase().replace(/\s/g, '')}`}>
            {name}
          </TileHeader>
          {priceAndCaloriesContent}
        </TileDescription>
      </Tile>
    );
  }
);

export default MenuTile;
